type NegativeSpaceSensitivitySliderProps = {
  sensitivity: number;
  onSensitivityChange: (value: number) => void;
};

export function NegativeSpaceSensitivitySlider({
  sensitivity,
  onSensitivityChange
}: NegativeSpaceSensitivitySliderProps) {
  return (
    <div className="flex gap-2 rounded-b-lg p-2 px-4">
      <div className="flex flex-col gap-2">
        <label
          htmlFor="negative-space-sensitivity"
          data-testid="negative-space-sensitivity-label"
          className="text-xs font-medium text-gray-700"
        >
          Sensitivity Threshold
        </label>
        <input
          data-testid="negative-space-sensitivity"
          id="negative-space-sensitivity"
          type="range"
          min={0}
          max={100}
          step={5}
          value={sensitivity}
          onChange={e => onSensitivityChange(Number(e.target.value))}
          className="design-lab-slider h-1 w-60 cursor-pointer appearance-none rounded-full bg-gray-200"
          style={{
            background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${sensitivity}%, #e5e7eb ${sensitivity}%, #e5e7eb 100%)`
          }}
        />
      </div>
      <div className="flex h-8 w-12 items-center justify-center rounded border border-gray-300 bg-gray-50 text-sm font-medium text-gray-800">
        {sensitivity}
      </div>
    </div>
  );
}
